import {updateResetToHome} from '../actions';
// Import the redux store
import {store} from '../configureStore';
import {adpAnalyticsLog, buildAdpAnalyticsPayload} from './utilADPAnalytics';
import {updateContainerEventMessage} from '../actions/uiActions';

const log = require('loglevel');
const setNeutrontHandler = () => {
  window.neutronJavaScriptHandler = {
    handle: (cmdId, raw_data) => {
      try {
        let aDpEvent;
        let getStore = store.getState();
        let uhmShowing = null;
        let uhmCollapsed = null;
        const {uiOptions: {requestId = ''} = {}} = getStore;
        /**
           *  Fusion will send one of the following cmdId when the user minimize, Expand, open and close respectively.
          "UHMCollapsed"
          "UHMUncollapsed"
          "UHMShow"
          "UHMHide"
           */

        // save value in store to send to Contact App as a prop
        if (
          ['UHMCollapsed', 'UHMUncollapsed', 'UHMShow', 'UHMHide'].includes(
            cmdId
          )
        ) {
          log.debug('receiveing event from Fusion to UHM: ', cmdId);
          switch (cmdId) {
            case 'UHMCollapsed': // UHM is mimized by the user
              if (uhmCollapsed === null || !uhmCollapsed) {
                // Send uhmCollapsed analytic here
                aDpEvent = 'uhm_minimize_click';
                store.dispatch(updateContainerEventMessage(cmdId));
              }
              uhmCollapsed = true;
              break;
            case 'UHMUncollapsed': // UHM is uncollapsed by the user
              if (uhmCollapsed === null || uhmCollapsed) {
                // Send uhmUncollapsed analytic here
                aDpEvent = 'uhm_unminimize_click';
                store.dispatch(updateContainerEventMessage(cmdId));
              }
              uhmCollapsed = false;
              break;
            case 'UHMHide': // Closed by the user
              // if the var is uninitialized or is changing values
              if (uhmShowing === null || uhmShowing) {
                // Send uhmHide analytic here
                aDpEvent = 'uhm_close_click';
                store.dispatch(updateContainerEventMessage(cmdId));
                // save value in store to send to Contact App as a prop
                // Reset the states to send the to Home.
                //contactModalityShowing
                if (
                  getStore.uiOptions &&
                  getStore.uiOptions.contactModalityShowing &&
                  getStore.uiOptions.contactModalityShowing === 'inline_chat'
                ) {
                  // The user is chatting with an agent so dont reset it.
                  /**
                   * TODO: Notify contact app  to let the agent know. May need to add new state in redux and pass it as a prop.
                   * */
                } else {
                  // / The user is chatting with an agent so okay to reset.
                  store.dispatch(updateResetToHome(true));
                }
              }
              uhmShowing = false;
              break;
            case 'UHMShow': // opened by the user.
              // if the var is uninitialized or is changing values
              if (uhmShowing === null || !uhmShowing) {
                // Send uhmShow analytic here
                /*UHMShow ADP analytics event is triggered in utilADPAnalytics
                uhm_icon_click > cs_page_view
              */
                store.dispatch(updateContainerEventMessage(cmdId));
              }
              uhmShowing = true;
              break;
            default:
              break;
          }

          aDpEvent &&
            adpAnalyticsLog(
              buildAdpAnalyticsPayload({
                e: aDpEvent,
                ev: true,
                cm_cs_request_id: requestId,
              })
            );
          //Reset the aDpEvent to null
          aDpEvent = null;
        }
      } catch (e) {
        console.log(
          'exception caught with command: ' +
            cmdId +
            ', data: ' +
            raw_data +
            ', exception: ' +
            e
        );
      }
      return 'OK';
    },
  };
};

export {setNeutrontHandler};
